import { useEffect } from 'react';
import { X, ShoppingCart, Dices } from 'lucide-react';
import { CoinIcon, SokoCoinIcon } from '@/app/components/SvgIcons';

export default function WalletInfoModal({ onClose }: { onClose: () => void }) {
    // Prevent body scroll when modal is open
    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    return (
        <div className="fixed inset-0 z-[100] flex items-start sm:items-center justify-center bg-black/60 backdrop-blur-sm p-4 overflow-y-auto" onClick={onClose}>
            <div className="rounded-2xl bg-gray-900 w-full max-w-md my-4 sm:my-8 overflow-hidden max-h-[calc(100dvh-2rem)] sm:max-h-[85vh] flex flex-col" onClick={e => e.stopPropagation()}>
                <div className="relative bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900 p-6 shrink-0">
                    <button onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white">
                        <X size={24} />
                    </button>
                    <div className="flex items-center gap-3">
                        <div>
                            <h2 className="text-2xl font-bold text-white">How to Earn Points</h2>
                            <p className="text-green-100 text-sm">Learn about our rewards system</p>
                        </div>
                    </div>
                </div>

                <div className="p-6 space-y-4 text-gray-200 overflow-y-auto">
                    <div className="flex items-start gap-3">
                        <CoinIcon size={20} className="mt-1" />
                        <div>
                            <h3 className="font-bold text-green-400 mb-1">Earn Kick Points</h3>
                            <p className="text-sm text-gray-300">
                                Get rewarded for your activity! Earn Kick Points by gifting, chatting, and subscribing.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start gap-3">
                        <ShoppingCart size={20} className="text-green-400 mt-1" />
                        <div>
                            <h3 className="font-bold text-green-400 mb-1">Redeem Rewards</h3>
                            <p className="text-sm text-gray-300">
                                Use your earned Kick Points to unlock exclusive items, rewards, and perks in the store.
                            </p>
                        </div>
                    </div>

                    <div className="pt-2 border-t border-gray-800" />

                    <div className="flex items-start gap-3">
                        <SokoCoinIcon size={20} className="mt-1" />
                        <div>
                            <h3 className="font-bold text-green-400 mb-1">Get Soko Points</h3>
                            <p className="text-sm text-gray-300">
                                Exchange Kick Points for Soko Points at a 1:1 rate (up to 1,000/day), or win more by playing SokoPlay games.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start gap-3">
                        <Dices size={20} className="text-green-400 mt-1" />
                        <div>
                            <h3 className="font-bold text-green-400 mb-1">Play & Cash Out</h3>
                            <p className="text-sm text-gray-300">
                                Spend Soko Points on SokoPlay — Slots, Blackjack, Roulette, Keno, and Mines — or exchange winnings back to Kick Points anytime.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}